//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import viewportMixin from '@/mixins/viewport.mixin';
import SelectFieldMobileMode from './selectFieldMobileMode.vue';

export default {
  components: { SelectFieldMobileMode },
  mixins: [viewportMixin],
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    // Используется чтобы запросить options с сервера
    optionsAction: {
      type: String,
      default: '',
    },
    // Используется чтобы взять options из стора
    optionsGetter: {
      type: String,
      default: '',
    },
    entity: {
      type: String,
      default: '',
    },
    mobileTitle: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },

    // VuetifySelect Props
    itemText: {
      type: String,
      default: 'label',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: '',
      options: [],
      fieldNode: null,
      mobileDisplay: false,
    };
  },
  computed: {
    filled() {
      if (this.multiple) {
        return this.model?.length;
      } else {
        return !!this.model;
      }
    },
    firstOptionIsAll() {
      const firstOption = this.options[0];
      const firstOptionValue = firstOption?.[this.itemValue];
      const firstOptionText = firstOption?.[this.itemText];
      return !firstOptionValue && !!firstOptionText;
    },
    labelForSelect() {
      if (!this.options.length) return this.placeholder;

      if (!this.multiple) {
        const selectedOption = this.options.find(
          (i) => i[this.itemValue] === this.model,
        );
        if (selectedOption) return selectedOption[this.itemText];
      }

      if (this.model?.length) {
        const count = this.model.length;
        const entity = this.entity;
        if (!entity) {
          return this.$tc('rt0822.multiselect.selected', count, { count });
        }
        return this.$tc(`rt0822.multiselect.${entity}.selected`, count, {
          count,
        });
      }

      if (this.firstOptionIsAll) {
        return this.options[0][this.itemText];
      }

      return this.placeholder;
    },
  },
  watch: {
    value: {
      handler(payload) {
        this.model = payload;
      },
      immediate: true,
    },
  },
  created() {
    this.fillOptions();
  },
  mounted() {
    if (!process.browser) {
      return;
    }
    this.fieldNode = this.$refs.field;
  },
  methods: {
    onInput(event) {
      this.multipleCheckSelectAll(event);
      this.$emit('input', this.model);
    },
    async fillOptions() {
      // Взять данные из стора
      if (this.optionsGetter) {
        const result = this.$store.getters[this.optionsGetter](this) || [];
        this.options = result;
      }

      // Запросить данные с сервера
      else if (this.optionsAction) {
        const result = await this.$store.dispatch(this.optionsAction, {
          vm: this,
        });
        this.options = result || [];
      } else {
        this.options = this.items || [];
      }
    },
    multipleCheckSelectAll(event) {
      if (!this.multiple) {
        return;
      }

      if (this.firstOptionIsAll) {
        if (event.includes('')) {
          this.model = [];
        }
      }
    },
    clickOnLabel() {
      if (this.isMobile) {
        this.mobileDisplay = true;
      }
    },
  },
};
